// @flow
import idx from 'idx';
import gql from 'graphql-tag';
import { addSequenceItemsToQueryResult } from './query';
import { getApolloClientSingleton } from 'lib/apollo/client/browser';
import { FIRST_PAGE_VAR } from '../components/AnnouncementStreamContainer';
import GET_ANNOUNCEMENT_STREAM_ITEMS from '../queries/GetAnnouncementStreamItems.gql';
import { dataIdFromObject } from 'lib/apollo/cache/memory';

export function updateEntityStreamPreview(uuid: string, date: Date, preview: string) {
  getApolloClientSingleton().writeFragment({
    id: dataIdFromObject({ __typename: 'EntityStream', uuid }),
    fragment: gql`
      fragment entityStreamPreview on EntityStream {
        preview {
          preview
          sentAt
        }
      }
    `,
    variables: { uuid },
    data: {
      preview: {
        preview,
        sentAt: date.toISOString(),
        __typename: 'StreamPreview',
      },
      __typename: 'EntityStream',
    },
  });
}

export function addAnnouncementStreamSequenceItem(
  streamUUID: string,
  item: *,
  options: { overrideSequenceNumber?: boolean } = {}
) {
  let result;

  try {
    result = getApolloClientSingleton().readQuery({
      query: GET_ANNOUNCEMENT_STREAM_ITEMS,
      variables: { uuid: streamUUID, ...FIRST_PAGE_VAR },
    });
  } catch (e) {
    // ignore cache update for stream that are not loaded yet.
    return;
  }

  const message = options.overrideSequenceNumber
    ? {
        ...item,
        seq: lastMessageItemSequenceNumber(streamUUID) + 1,
      }
    : item;

  getApolloClientSingleton().writeQuery({
    query: GET_ANNOUNCEMENT_STREAM_ITEMS,
    variables: { uuid: streamUUID, ...FIRST_PAGE_VAR },
    data: addSequenceItemsToQueryResult(result, [message]),
  });

  // update the Apollo store so that the preview updates
  updateEntityStreamPreview(streamUUID, new Date(), item.item.preview);
}

export function lastMessageItemSequenceNumber(uuid: *) {
  let result;

  try {
    result = getApolloClientSingleton().readQuery({
      query: GET_ANNOUNCEMENT_STREAM_ITEMS,
      variables: { uuid, ...FIRST_PAGE_VAR },
    });
  } catch (e) {
    return 0;
  }

  return Number(idx(result, _ => _.entityStreams[0].sequenceItems[0].seq) || 0);
}
